import { doesPathnameMatchAnyPageRule, useLogger } from '@omnia/ui/src/lib'
import { type FC, useMemo } from 'react'
import { useLocation } from 'react-router-dom-v7'
import { cmsDataService } from '@/common/services/cms.data.service'

const ComponentName = 'ElementDisplayRules'

export const ElementDisplayRules: FC = () => {
    const currentPage = useLocation().pathname
    const logger = useLogger(ComponentName)

    const displayElementRules = useMemo(() => {
        return cmsDataService.get().elementDisplayRules || []
    }, [])

    const selectors = useMemo(() => {
        return displayElementRules
            .filter(rule => !doesPathnameMatchAnyPageRule(currentPage, rule.pagesToShow))
            .map(rule => rule.selector)
    }, [currentPage, displayElementRules])

    logger.debug('Elements being hidden on page by display rules', selectors)

    return (
        <>
            {selectors.length > 0 && (
                <style>{selectors.map(selector => `${selector} { display: none !important; }`).join(' ')}</style>
            )}
        </>
    )
}

ElementDisplayRules.displayName = ComponentName
